import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { PATRIMOINE_COLLECTIVITES } from '../../../../config/patrimoine-collectivites';

export default function EhpadPage() {
  const parcours = PATRIMOINE_COLLECTIVITES.find((p) => p.slug === 'ehpad');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="collectivites"
      segment="patrimoine"
      segmentLabel="Patrimoine"
    />
  );
}
